/**
 * シフト情報
 */
export interface Shift {
  id: string;
  shopId: string;
  employeeId: string;

  // シフト日時
  shiftDate: Date;
  startTime: string;  // HH:mm形式
  endTime: string;
  breakMinutes: number;

  // シフトタイプ
  shiftType: 'regular' | 'overtime' | 'holiday';

  // ステータス
  status: 'requested' | 'pending' | 'approved' | 'rejected';

  // メモ
  note?: string;

  // 承認情報
  approvedBy?: string;
  approvedAt?: Date;
  rejectionReason?: string;

  // システム情報
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
}

/**
 * シフトタイプの日本語表示
 */
export const shiftTypeLabels: Record<Shift['shiftType'], string> = {
  regular: '通常',
  overtime: '残業',
  holiday: '休日出勤',
};

/**
 * シフトステータスの日本語表示
 */
export const shiftStatusLabels: Record<Shift['status'], string> = {
  requested: '希望',
  pending: '未確定',
  approved: '確定',
  rejected: '却下',
};

/**
 * シフトステータスの色
 */
export const shiftStatusColors: Record<Shift['status'], 'default' | 'primary' | 'success' | 'warning' | 'error'> = {
  requested: 'warning',
  pending: 'default',
  approved: 'success',
  rejected: 'error',
};
